import { Navigate, Route, Routes } from "react-router-dom";
import { AppLayout, CustomerLayout, ResellerLayout } from "./components/AppLayout";
import { AdminRoute, ProtectedRoute } from "./components/ProtectedRoute";
import { ArtifactsPage } from "./pages/ArtifactsPage";
import { DashboardPage } from "./pages/DashboardPage";
import { CreditsPage, WalletsPage } from "./pages/FinancePages";
import { FraudPage } from "./pages/FraudPage";
import { LicensesPage } from "./pages/LicensesPage";
import { LoginPage } from "./pages/LoginPage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { PluginBuilderPage } from "./pages/PluginBuilderPage";
import { PluginsPage } from "./pages/PluginsPage";
import { PluginUiPage } from "./pages/PluginUiPage";
import { PluginUsersPage } from "./pages/PluginUsersPage";
import { ResellerPortalPage } from "./pages/ResellerPortalPage";
import { CustomerPortalPage } from "./pages/CustomerPortalPage";
import { ResellersPage } from "./pages/ResellersPage";
import { VouchersPage } from "./pages/VouchersPage";
import { BackupsPage } from "./pages/BackupsPage";
import { NotificationsPage } from "./pages/NotificationsPage";
import { OrdersPage } from "./pages/OrdersPage";
import { AppliancesPage } from "./pages/AppliancesPage";
import { AccountPage, AuditPage, CustomersPage, DevicesPage, OperationPricesPage, OperationsPage, PaymentsPage, PlansPage, ProductsPage, ResourcesPage, SettingsPage, UpdatesPage } from "./pages/ResourcePages";

export function App() {
  return <Routes>
    <Route path="/login" element={<LoginPage />} />
    <Route element={<ProtectedRoute />}>
      <Route path="/reseller" element={<ResellerLayout />}><Route index element={<ResellerPortalPage />} /></Route>
      <Route path="/customer" element={<CustomerLayout />}><Route index element={<CustomerPortalPage />} /></Route>
      <Route element={<AdminRoute />}><Route element={<AppLayout />}>
        <Route index element={<DashboardPage />} />
        <Route path="products" element={<ProductsPage />} /><Route path="plans" element={<PlansPage />} /><Route path="customers" element={<CustomersPage />} /><Route path="resellers" element={<ResellersPage />} />
        <Route path="wallets" element={<WalletsPage />} /><Route path="vouchers" element={<VouchersPage />} /><Route path="orders" element={<OrdersPage />} /><Route path="payments" element={<PaymentsPage />} />
        <Route path="licenses" element={<LicensesPage />} /><Route path="devices" element={<DevicesPage />} /><Route path="appliances" element={<AppliancesPage />} /><Route path="resources" element={<ResourcesPage />} /><Route path="credits" element={<CreditsPage />} />
        <Route path="operations" element={<OperationsPage />} /><Route path="operation-prices" element={<OperationPricesPage />} />
        <Route path="artifacts" element={<ArtifactsPage />} /><Route path="updates" element={<UpdatesPage />} /><Route path="plugins" element={<PluginsPage />} /><Route path="plugins/builder" element={<PluginBuilderPage />} />
        <Route path="plugins/:id/ui" element={<PluginUiPage />} /><Route path="plugin-users" element={<PluginUsersPage />} /><Route path="notifications" element={<NotificationsPage />} />
        <Route path="audit" element={<AuditPage />} /><Route path="fraud" element={<FraudPage />} /><Route path="settings" element={<SettingsPage />} /><Route path="backups" element={<BackupsPage />} /><Route path="account" element={<AccountPage />} />
      </Route></Route>
    </Route>
    <Route path="/404" element={<NotFoundPage />} /><Route path="*" element={<Navigate to="/404" replace />} />
  </Routes>;
}
